export default __webpack_public_path__ + "static/media/army_13.f96253f0.jpg";